"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;
var _loaderModule = _interopRequireDefault(require("@albelli/arc-3/lib/loader.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Loader = _ref => {
  let {
    size = "ultra-large",
    spaceHolder,
    container = true,
    className,
    ...props
  } = _ref;
  const [userAgent, setUserAgent] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    setUserAgent(window && window.navigator && window.navigator.userAgent);
  }, []);
  const isIE = userAgent && (userAgent.indexOf("MSIE ") >= 0 || userAgent.indexOf("Trident/") >= 0 || userAgent.indexOf("Edge/") >= 0);
  const loaderClass = isIE ? _loaderModule.default["arc3-loader-simple"] : _loaderModule.default["arc3-loader"];
  const loader = /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(loaderClass, _loaderModule.default["arc3-loader--" + size], className),
    "data-cy": "Arc3Loader"
  }, props));
  const result = container ? /*#__PURE__*/_react.default.createElement("div", {
    className: _loaderModule.default["arc3-loader-placement"]
  }, loader) : loader;
  return spaceHolder ? /*#__PURE__*/_react.default.createElement("div", {
    className: _loaderModule.default["arc3-loader-spaceholder"]
  }, result) : result;
};
exports.Loader = Loader;
Loader.propTypes = {
  /** Sizing of loader */
  size: _propTypes.default.oneOf(["ultra-small", "extra-small", "small", "medium", "large", "extra-large", "ultra-large"]),
  /** Should place in the containing div, defaults to true */
  container: _propTypes.default.bool
};